import { Environment, Environments, RuntimeEnvironment } from '@utils/envUtils';

type ApiUrlWithKey = {
  key: string;
  url: string;
};

type ApiEnvConfig = {
  api: ApiUrlWithKey;
  cdn?: ApiUrlWithKey;
  cdnCacheApi?: ApiUrlWithKey;
};

// Defined in public/config.js
// Included separately from main bundle such that infra teams can use the same image but vary config
declare const tvStudioApiConfig: Partial<Record<Environment, ApiEnvConfig>>;

export const apiConfig = tvStudioApiConfig;

export const isLocal = import.meta.env.DEV;
const runtimeEnv: RuntimeEnvironment | string | undefined = isLocal
  ? import.meta.env.VITE__ENV
  : Object.keys(apiConfig).at(0);

const isEnv = (str?: string): str is Environment =>
  !!str && ([...Environments] as string[]).includes(str);

const checkEnv = (str?: string): Environment => (isEnv(str) ? str : 'prod');

const getEnv = (): Environment => checkEnv(runtimeEnv === 'local-apim' ? 'local' : runtimeEnv);

const env = getEnv();
export const useLocalServicePorts = isLocal && runtimeEnv === 'local';

export default env;
